
  import React from "react"
  import Component from "/Applications/MAMP/htdocs/nigala-web/src/layouts/index.js"
  import data from "/Applications/MAMP/htdocs/nigala-web/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js